export enum adminAdministratorsRegionsTypes {
  FETCH_ADMIN_ADMINISTRATORS_REGIONS_REQUEST = "FETCH_ADMIN_ADMINISTRATORS_REGIONS_REQUEST",
  FETCH_ADMIN_ADMINISTRATORS_REGIONS_SUCCESS = "FETCH_ADMIN_ADMINISTRATORS_REGIONS_SUCCESS",
  FETCH_ADMIN_ADMINISTRATORS_REGIONS_FAILURE = "FETCH_ADMIN_ADMINISTRATORS_REGIONS_FAILURE",
}